// Constants
import { DEFAULT_LINES } from '@/components/common/DotGridBackground/constants';

// Types
import { DotGridBackgroundProps } from '@/components/common/DotGridBackground/types';
import { MonthsOffsets, ProjectsOffsets } from './components/types';

export const DOT_GRID_BACKGROUND_CONFIG: DotGridBackgroundProps = {
  hiddenRegions: [
    {
      minX: 6,
      maxX: 12,
      minY: 3,
      maxY: 7,
    },
  ],
  lines: [
    ...DEFAULT_LINES,
    {
      points: [
        {
          x: 2,
          y: 6,
        },
        {
          x: 2,
          y: 8,
        },
        {
          x: 4,
          y: 8,
        },
        {
          x: 4,
          y: 10,
        },
      ],
    },
    {
      points: [
        {
          x: 14,
          y: 2,
        },
        {
          x: 14,
          y: 6,
        },
      ],
    },
  ],
};

export const ANIMATION_CONFIG = {
  projectListComponent: {
    animationStartFrame: 40,
    batchDisplayDuration: 75,
    projectsPerBatch: 2,
    slideDistance: 400,
    staggerDelay: 10,
    fadeDuration: 20,
    // Extra frames for exit animation and buffer
    // Adding 90 frames (3 seconds at 30fps) for last project to display before transition
    exitAnimationBuffer: 90,
  },
  projectStatsComponent: {
    projectsInitial: {
      top: 424,
      left: 888,
    },
    monthsInitial: {
      top: 734,
      left: 1354,
    },
    projectsFinal: {
      top: 70,
      left: 150,
    },
    monthsFinalOffsets: {
      bottom: 150,
      right: 127,
    },
    labelTranslateX: -110,
    labelTranslateY: 400,
  },
};

// Maximum number of projects to display (show only most recent)
export const MAX_DISPLAY_PROJECTS = 5;

export const DEFAULT_PROJECTS_OFFSET: ProjectsOffsets = {
  initialLeftOffset: 0,
  finalLeftOffset: 40,
  labelTranslateXOffset: 0,
};

/**
 * Lookup table for project stat position offsets, ordered by descending threshold.
 * Each entry: [minCount, initialLeftOffset, finalLeftOffset, labelTranslateXOffset]
 */
export const PROJECTS_OFFSET_THRESHOLDS: [number, number, number, number][] = [
  [90, -114, -30, -60],
  [80, -113, -30, -60],
  [70, -117, -13, -60],
  [50, -112, -20, -60],
  [40, -118, -55, -60],
  [30, -112.5, -25, -60],
  [20, -118, -30, -60],
  [10, -113, -35, -60],
];

export const DEFAULT_MONTHS_OFFSET: MonthsOffsets = {
  initialLeftOffset: 101,
  finalLeftOffset: -130,
  labelTranslateXOffset: -5,
};

/**
 * Lookup table for months stat position offsets, ordered by descending threshold.
 * Each entry: [minMonths, initialLeftOffset, finalLeftOffset, labelTranslateXOffset]
 */
export const MONTHS_OFFSET_THRESHOLDS: [number, number, number, number][] = [
  [10, 114.7, -20, -70],
  [9, 4, -130, -5],
  [8, 0, -130, -5],
  [7, 2, -130, -5],
  [5, 0, -130, -5],
  [4, 6, -130, -5],
  [1, 0, -130, -5],
];
